import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import { BACKEND_URL } from '../config/constants';

const PdfCentroCirurgico = ({ title, list, theme }) => {
  const componentRef = useRef();
  const textIcon = (theme === 'dark' ? '_dark' : ''); 

  const handlePrint = useReactToPrint({
    documentTitle: 'Relatório Mapa Cirurgico',
    content: () => componentRef.current,
    // onAfterPrint: () => alert('Print sucess')
  });

  return (
    <>
      <button className={'buttonIcon '+theme}><img src={"/img/icon_printer"+textIcon+".svg"} alt="" onClick={handlePrint} /></button>
      <div style={{ display: 'none' }}>
        <div ref={componentRef} style={{ width: '100%', height: window.innerHeight }}>
          <div className='inforow' style={{marginTop: '40px',marginLeft: '80px', marginRight: '80px'}}>
            <div className="inforow right">
              <h3 style={{fontSize: '20px'}}>{title}</h3 >
            </div>
            <div className="inforow left">
              <img src="/img/logo_powered_insightcare.png" alt="Insightcare" style={{width: '12vw', position:'relative', marginLeft: '32px', float: 'right'}}/>
							{
								BACKEND_URL.includes('gruposanta') ? (
									<img src="/img/logo_gruposanta.png" alt="Gruposanta" style={{ width: '12vw', position: 'relative', float: 'right', marginLeft: '25px' }} />
								) : null
							}
            </div>
          </div>
          <div className="inforow" style={{marginLeft: '80px', marginRight: '80px'}}>
            <div className='inforow right'>
              <div className='infoText' style={{fontSize: '12px'}}>Mostrando {list.length} pacientes </div>
            </div>
            <div className='inforow left'>
              <div className='infoText' style={{fontSize: '12px'}}>Impresso em {moment().format('HH:mm, [dia] D [de] MMMM [de] YYYY')}</div>
            </div>
          </div>
          <div className='tablePDF'>
            <table>
              <thead>
                <tr>
                  <th>Status</th>
                  <th>Sala</th>
                  <th>Paciente</th>
                  <th>Cirurgião</th>
                  <th>Cirurgia </th>
                  <th>Previsão</th>
                </tr>
              </thead>
              <tbody>
                {list.map((data) => {
                  let color = '';
                  let statusClass = "ready";
                  let situacao = data.SITUACAO;
                  let tdClassFarm = "";
                  let spanClassFarm = "";
									let name = data.NM_PACIENTE;
									if (BACKEND_URL.includes('gruposanta')) {
										name = data.NM_PACIENTE.split(' ').slice(-1).join(' ') + ', ' + data.NM_PACIENTE.split(' ')[0].slice(0, 1);
									}
                  let cirurgiao = data.CIRURGIAO.split(' ')[0] + ' ' + data.CIRURGIAO.split(' ').slice(-1).join(' ');
                  let horario = data.HR_INICIO;
                  let cirurgia = data.CD_AVISO_CIRURGIA;
                  cirurgia = cirurgia + '-' + data.DS_CIRURGIA;

                  if (data.SITUACAO === 'Realizada') {
                    statusClass = "ready";
                  } else if (data.SITUACAO === 'Cancelada') {
                    statusClass = 'canceled';
                    color = 'red';
                  } else if (data.SITUACAO === 'Agendada') {
                    statusClass = 'scheduled';
                    color = 'grey';
                  } else {
                    statusClass = "waiting";
                    if (data.PROGRESSO != null && data.PROGRESSO.length > 1) {
                      statusClass = 'progress';
                      situacao = data.PROGRESSO;
                    }
                  }

                  if (data.PREVISAO != null && data.PREVISAO.length > 1) {
                    horario = horario + ' às ' + data.PREVISAO;
                  }

                  return (
                    <tr key={data.CD_AVISO_CIRURGIA +'-'+ data.CD_CIRURGIA_AVISO} className={statusClass}>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left" > <div className="alert-label" /> <b>{situacao}</b></td>
                      <td style={{ color: color }} align="left">{data.SALA}</td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left"  ><b>{name}</b> | {data.DT_NASCIMENTO} </td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left">{cirurgiao}</td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap' }} align="left">{cirurgia.slice(0, 50)}</td>
                      <td className={tdClassFarm} align="left"><span className={spanClassFarm}></span>{horario}</td>
                    </tr>
                  )
                })
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default PdfCentroCirurgico;